import { usePayeeQuery } from "../../../../query/payee/queries/usePayeeQuery";
import React from "react";
import { getPayeeName } from "../../../Payees/selectors/getPayeeNames";
import { WSElement, WSText } from "@wingspanhq/fe-component-library";

export const PayeeName: React.FC<{ payeeId: string }> = ({ payeeId }) => {
  const queryPayee = usePayeeQuery(payeeId);

  if (queryPayee.data) {
    return <>{getPayeeName(queryPayee.data)}</>;
  } else if (queryPayee.isError) {
    return <WSText.ParagraphXs color="red500">error</WSText.ParagraphXs>;
  } else {
    return <WSElement as="i" shimmer pb="L" style={{ display: "block" }} />;
  }
};
